module.exports = __webpack_public_path__ + "media/banners/benefit-4f8137ce.png";